import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalTitle, Input, RadioGroup, RadioGroupAdapter, FormItem } from '@vertesia/ui/core';
import { useUITranslation } from '@vertesia/ui/i18n';
class SaveOptionAdapter extends RadioGroupAdapter {
    idOf(item) { return item.id; }
    labelOf(item) { return item.label; }
    descriptionOf(item) { return item.description; }
    selectedClassName(_item) { return 'border-3 border-primary'; }
}
export function SaveVersionConfirmModal({ isOpen, onClose, onConfirm, isLoading, uploadedFileName }) {
    const { t } = useUITranslation();
    const saveOptions = [
        {
            id: "update",
            label: t('modal.saveVersion.updateCurrent'),
            description: uploadedFileName
                ? t('modal.saveVersion.updateWithFileDescription')
                : t('modal.saveVersion.updateDescription')
        },
        {
            id: "new-version",
            label: t('modal.saveVersion.createNew'),
            description: uploadedFileName
                ? t('modal.saveVersion.createWithFileDescription')
                : t('modal.saveVersion.createDescription')
        }
    ];
    // Default to "create new version" when replacing a file, "update current version" when editing properties
    const defaultOption = uploadedFileName ? saveOptions[1] : saveOptions[0];
    const [selectedOption, setSelectedOption] = useState(defaultOption);
    const [versionLabel, setVersionLabel] = useState('');
    const optionAdapter = new SaveOptionAdapter();
    // Reset to default when modal opens or uploadedFileName changes
    useEffect(() => {
        if (isOpen) {
            setSelectedOption(defaultOption);
            setVersionLabel('');
        }
    }, [isOpen, uploadedFileName]);
    const createVersion = selectedOption?.id === "new-version";
    const handleOptionChange = (option) => {
        setSelectedOption(option);
    };
    const handleConfirm = async () => {
        await onConfirm(createVersion, createVersion ? versionLabel : undefined);
    };
    return (_jsxs(Modal, { isOpen: isOpen, onClose: onClose, className: "sm:max-w-md", children: [_jsx(ModalTitle, { children: t('modal.saveChanges') }), _jsx(ModalBody, { children: _jsxs("div", { className: "space-y-4", children: [uploadedFileName && (_jsx("div", { className: "mb-4 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-md", children: _jsxs("p", { className: "text-sm text-blue-700 dark:text-blue-300 font-medium", children: [t('modal.saveVersion.replaceFile'), " ", _jsx("span", { className: "font-bold", children: uploadedFileName })] }) })), _jsx("p", { className: "text-sm text-mixer-muted/5", children: t('modal.saveVersion.howToSave') }), _jsx(RadioGroup, { adapter: optionAdapter, options: saveOptions, selected: selectedOption, onSelect: handleOptionChange }), createVersion && (_jsx(FormItem, { label: t('modal.saveVersion.versionLabel'), description: t('modal.saveVersion.versionLabelDescription'), className: "mt-3 pl-8", children: _jsx(Input, { value: versionLabel, onChange: setVersionLabel, placeholder: t('modal.saveVersion.versionLabelPlaceholder'), className: "w-full" }) }))] }) }), _jsxs(ModalFooter, { children: [_jsx(Button, { variant: "secondary", onClick: onClose, disabled: isLoading, children: t('modal.cancel') }), _jsx(Button, { variant: "primary", onClick: handleConfirm, isLoading: isLoading, children: t('modal.save') })] })] }));
}
//# sourceMappingURL=SaveVersionConfirmModal.js.map